import React from "react";

export default function ErrorPageView() {
  return (
    <div className="row justify-content-center">
      <h1>Страница не найдена!</h1>;
    </div>
  );
}
